import { FC } from 'react';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import SpotDetail from '@/views/expandstore/pages/spotdetail/index';

/**
 * @Description 客流计数 - 任务详情抽屉
 */
const SpotDetailDrawer: FC<{
  data: any;
  setData: any;
  /** 是否展示演示模式 */
  isDemonstrate?: boolean;
  /** 是否展示机会点操作 */
  ableToChangepoint?: boolean;
}> = ({ data, setData, isDemonstrate, ableToChangepoint = true }) => {

  return (
    <V2Drawer open={data.visible} onClose={() => setData(false)}>
      {data.data?.id && <SpotDetail id={data.data?.id} isDemonstrate={isDemonstrate} ableToChangepoint={ableToChangepoint} /> }
    </V2Drawer>
  );
};
export default SpotDetailDrawer;
